import markConversationsReadInListViewStore from '../actions/triage/markConversationsReadInListViewStore';
import markConversationsAsReadStoreUpdate from 'owa-mail-actions/lib/triage/markConversationsAsReadStoreUpdate';
import { listViewStore } from 'owa-mail-list-store';
import { getRowKeysFromRowIds } from 'owa-mail-list-store';
import { orchestrator } from 'satcheljs';
export default orchestrator(markConversationsAsReadStoreUpdate, function (actionMessage) {
    var conversationIds = actionMessage.conversationIds, tableViewId = actionMessage.tableViewId, isReadValue = actionMessage.isReadValue;
    // Get all the rowKeys for the given conversation and update the unread count
    var tableView = listViewStore.tableViews.get(tableViewId);
    var rowKeys = getRowKeysFromRowIds(conversationIds, tableView);
    markConversationsReadInListViewStore(rowKeys, isReadValue, tableView, true /* updateFolderCounts */);
});
//# sourceMappingURL=markConversationsAsReadStoreUpdateOrchestrator.js.map